import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FilterDTO } from '../../models/FilterDTO';

@Component({
  selector: 'app-filter-map-autocomplete',
  templateUrl: './filter-map-autocomplete.component.html',
  styleUrls: ['./filter-map-autocomplete.component.css']
})
export class FilterMapAutocompleteComponent implements OnInit {
  @Input() form: FormGroup
  @Input() filter: any;
  @Input() selected: string;
  @Output() onOptionSelected = new EventEmitter<FilterDTO>();
  @Output() onOptionDeleted = new EventEmitter<FilterDTO>();

  myControl = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  constructor() {
    
  }

  ngOnInit() {
    this.options = this.filter.values;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );
  }

  onDelete() : void {
    this.selected = '';
    const filter = { 
      key: this.filter.key,
      value: this.selected
    } as FilterDTO;
    this.onOptionDeleted.emit(filter);
  }

  onSelect(option: string){
    this.selected = option;
    const filter = { 
      key: this.filter.key,
      value: option
    } as FilterDTO;
    this.onOptionSelected.emit(filter);
  }

  private _filter(value: string): string[] {
    const filterValue = (value ?? "").toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }
}
